export default __webpack_public_path__ + "static/media/covidData.1da3e523.jpg";